import { render, staticRenderFns } from "./ExpandableItemIncapacidades.vue?vue&type=template&id=676b5a2e&scoped=true"
import script from "./ExpandableItemIncapacidades.vue?vue&type=script&lang=js"
export * from "./ExpandableItemIncapacidades.vue?vue&type=script&lang=js"
import style0 from "./ExpandableItemIncapacidades.vue?vue&type=style&index=0&id=676b5a2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676b5a2e",
  null
  
)

export default component.exports